module.exports = __webpack_public_path__ + "static/media/undraw_adventure_4hum 1.eae25da4.svg";